import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {Button, Card, Col, Form, Row} from "react-bootstrap";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl} from "../Univ";
const SensorReading = () => {
    const [readings, setReadings] = useState([]);
    const [loading, setLoading] = useState(false);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
// ==================================
// LOAD SENSOR DATA
// ==================================
    const loadReadings = async () => {
        try {
            setLoading(true);
            let url = baseUrl + "sensor-reading/";
            if (fromDate && toDate) {
                url += `?from=${fromDate}&to=${toDate}`;
            }
            const res = await axios.get(url);
            setReadings(res.data);
        } catch (error) {
            Swal.fire("Error",
                "Unable to load sensor readings",
                "error");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        loadReadings();
    }, []);
// ==================================
// SENSOR SUMMARY
// ==================================
    const temperature =
        readings.filter(x => x.sensor_type === "Temperature");
    const moisture =
        readings.filter(x => x.sensor_type === "Moisture");
    const weather =
        readings.filter(x => x.sensor_type === "Weather");
    const latestValue = (arr) => {
        if (arr.length > 0)
            return arr[arr.length - 1].sensor_value;
        return 0;
    };
    const columns = [
        {
            field: "id",
            headerName: "ID",
            width: 80
        },
        {
            field: "device_name",
            headerName: "Device",
            flex: 1,
            valueGetter: (params) =>
                params.row.device_name ||
                params.row.device?.device_name
        },
        {
            field: "sensor_type",
            headerName: "Sensor",
            flex: 1
        },
        {
            field: "sensor_value",
            headerName: "Value",
            width: 120
        },
        {
            field: "unit",
            headerName: "Unit",
            width: 100
        },
        {
            field: "reading_time",
            headerName: "Reading Time",
            width: 200
        }
    ];
    return (
        <>


            <Row className="mb-3">


                <Col md={4}>


                    <Card className="shadow">


                        <Card.Body>


                            <h6>
                                Temperature
                            </h6>


                            <h2>

                                {latestValue(temperature)}

                                °C

                            </h2>


                        </Card.Body>


                    </Card>


                </Col>


                <Col md={4}>


                    <Card className="shadow">


                        <Card.Body>


                            <h6>
                                Soil Moisture
                            </h6>


                            <h2>

                                {latestValue(moisture)}

                                %

                            </h2>


                        </Card.Body>


                    </Card>


                </Col>


                <Col md={4}>


                    <Card className="shadow">


                        <Card.Body>


                            <h6>
                                Weather Sensor
                            </h6>


                            <h2>

                                {latestValue(weather)}

                            </h2>


                        </Card.Body>


                    </Card>


                </Col>


            </Row>


            <Card className="shadow">


                <Card.Header>


                    <h5>

                        Sensor Reading Dashboard

                    </h5>


                </Card.Header>


                <Card.Body>


                    <Row className="mb-3">


                        <Col md={4}>


                            <Form.Label>

                                From Date

                            </Form.Label>


                            <Form.Control

                                type="date"

                                value={fromDate}

                                onChange={(e) => setFromDate(e.target.value)}

                            />


                        </Col>


                        <Col md={4}>


                            <Form.Label>

                                To Date

                            </Form.Label>


                            <Form.Control

                                type="date"

                                value={toDate}

                                onChange={(e) => setToDate(e.target.value)}

                            />


                        </Col>


                        <Col md={4}

                             className="d-flex align-items-end"

                        >


                            <Button

                                variant="primary"

                                onClick={loadReadings}

                            >

                                Search

                            </Button>


                        </Col>


                    </Row>


                    <div

                        style={{
                            height: 500,
                            width: "100%"
                        }}

                    >


                        <ERPDataGrid


                            rows={readings}


                            columns={columns}


                            loading={loading}


                        />


                    </div>


                </Card.Body>


            </Card>


        </>
    );
};
export default SensorReading;